/**
 * Splits a catalog titleWithId string into title and trailing numeric id.
 * @param {unknown} label - e.g. "MARVEL RISING (SHORTS) (88932)"
 * @returns {{ title: string, id: string } | null}
 */
export function parseCatalogTitleWithId(label) {
  const text = String(label ?? "").trim();
  if (!text) {
    return null;
  }

  const spaced = text.match(/^(.*)\s+\((\d+)\)\s*$/);
  if (spaced && spaced[1].trim()) {
    return {
      title: spaced[1].trim(),
      id: spaced[2],
    };
  }

  const compact = text.match(/^(.*)\((\d+)\)\s*$/);
  if (compact && compact[1].trim()) {
    return {
      title: compact[1].trim(),
      id: compact[2],
    };
  }

  return null;
}

/**
 * Title and id for catalog pills; prefers API name/id over parsing titleWithId.
 * @param {string | { name?: string, id?: unknown, titleWithId?: string, label?: string }} item
 * @returns {{ title: string, id: string } | null}
 */
export function resolveCatalogPillParts(item) {
  if (item == null) {
    return null;
  }

  if (typeof item === "string") {
    return parseCatalogTitleWithId(item);
  }

  const parsed = parseCatalogTitleWithId(
    item.titleWithId ?? item.label ?? "",
  );
  const name = item.name?.trim();
  const id =
    item.id != null && item.id !== "" ? String(item.id) : parsed?.id ?? null;

  if (name && id) {
    return { title: name, id };
  }

  return parsed;
}
